export default __webpack_public_path__ + "static/media/lundsgaardgods.15675863.jpg";